import SbResolve from './SbResolve';

const TextTruncate = function (
  text,
  length = 200,
  ellipsis = '...',
  richtext = false,
) {
  function decodeHtml(html) {
    if (typeof window !== `undefined`) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }
    return html;
  }
  let output = text;

  if (richtext) {
    output = decodeHtml(SbResolve(text).replace(/<[^>]+>/g, ''));
  }

  if (output) {
    output = output
      .replace(/[.]/g, '. ')
      .replace(/[?]/g, '? ')
      .replace(/[!]/g, '! ');
  }

  if (output === null) return output;

  if (output.length <= length) return output;
  return output.substr(0, output.lastIndexOf(' ', length)) + ellipsis;
};

export { TextTruncate };
